export default __webpack_public_path__ + "306deae73c2ce54116e58c1b44211153.svg";